import { useCallback, useState } from "react";
import { useAuthStore } from "@/stores/useAuthStore";
import { message } from "antd";
import AuditStatusModal from "@/components/modals/AuditStatusModal";

export type HeaderTab = "ai" | "about" | "feedback";

export function useHeaderNav() {
  const [active, setActive] = useState<HeaderTab>("ai");
  const [contactOpen, setContactOpen] = useState(false);
  const [loginPromptOpen, setLoginPromptOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [auditStatusModalOpen, setAuditStatusModalOpen] = useState(false);
  const [auditStatus, setAuditStatus] = useState<string>("");
  const [previousActive, setPreviousActive] = useState<HeaderTab>("ai");
  const token = useAuthStore((s) => s.token);

  // 全局Modal状态，用于暂停页面动画
  const hasModalOpen =
    contactOpen ||
    loginPromptOpen ||
    loginOpen ||
    feedbackOpen ||
    auditStatusModalOpen;

  const openContact = useCallback(() => setContactOpen(true), []);
  const closeContact = useCallback(() => {
    setContactOpen(false);
    setActive("ai");
    // 发送全局事件，通知 Footer 组件页面已关闭
    window.dispatchEvent(new CustomEvent("contactUsClosed"));
  }, []);

  const openFeedback = useCallback(() => setFeedbackOpen(true), []);
  const closeFeedback = useCallback(() => {
    setFeedbackOpen(false);
    setActive(previousActive); // 回到之前的状态
  }, [previousActive]);

  const selectAi = useCallback(() => {
    console.log("[Header] Click: AI 指数");
    setActive("ai");
    setContactOpen(false); // 关闭加入内测联盟弹窗
  }, []);

  const selectContact = useCallback(() => {
    setPreviousActive(active); // 记住当前选中状态
    setActive("about");
    // 检查审核状态
    const auditStatus = localStorage.getItem("audit_status");
    if (auditStatus === "0" || auditStatus === "1" || auditStatus === "2") {
      // 设置审核状态并打开模态框
      setAuditStatus(auditStatus);
      setAuditStatusModalOpen(true);
      return;
    }

    // 不再检查登录状态，直接打开内测联盟页面
    setContactOpen(true);
  }, [active]);

  const selectFeedback = useCallback(() => {
    // 如果当前是about（加入内测联盟），则记住之前的状态
    // 否则记住当前状态
    if (active === "about") {
      // 保持previousActive不变，因为我们要回到更早的状态
    } else {
      setPreviousActive(active); // 记住当前选中状态
    }
    setActive("feedback");
    setContactOpen(false); // 关闭加入内测联盟弹窗
    if (token) {
      setFeedbackOpen(true);
    } else {
      // 设置登录来源为feedback，用于登录成功后打开正确的模态框
      localStorage.setItem("loginSource", "feedback");
      setLoginPromptOpen(true);
    }
  }, [token, active]);

  return {
    active,
    contactOpen,
    loginPromptOpen,
    loginOpen,
    feedbackOpen,
    auditStatusModalOpen,
    auditStatus,
    hasModalOpen,
    setActive,
    openContact,
    closeContact,
    openFeedback,
    closeFeedback,
    setContactOpen,
    setLoginPromptOpen,
    setLoginOpen,
    setFeedbackOpen,
    setAuditStatusModalOpen,
    selectAi,
    selectContact,
    selectFeedback,
  };
}

export default useHeaderNav;
